import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNextStep = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M15 14C14.1174 13.1174 13.6762 12.6762 13.6274 12.1346C13.6193 12.045 13.6193 11.955 13.6274 11.8654C13.6762 11.3238 14.1174 10.8826 15 10C15.8826 9.11744 16.3238 8.67615 16.8654 8.62737C16.955 8.6193 17.045 8.6193 17.1346 8.62737C17.6762 8.67615 18.1174 9.11744 19 10C19.8826 10.8826 20.3238 11.3238 20.3726 11.8654C20.3807 11.955 20.3807 12.045 20.3726 12.1346C20.3238 12.6762 19.8826 13.1174 19 14C18.1174 14.8826 17.6762 15.3238 17.1346 15.3726C17.045 15.3807 16.955 15.3807 16.8654 15.3726C16.3238 15.3238 15.8826 14.8826 15 14Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4.29289 6.29289C4.68342 5.90237 5.31658 5.90237 5.70711 6.29289L10.7071 11.2929C11.0976 11.6834 11.0976 12.3166 10.7071 12.7071L5.70711 17.7071C5.31658 18.0976 4.68342 18.0976 4.29289 17.7071C3.90237 17.3166 3.90237 16.6834 4.29289 16.2929L8.58579 12L4.29289 7.70711C3.90237 7.31658 3.90237 6.68342 4.29289 6.29289Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgNextStep);
export { ForwardRef as ReactComponent };
